export default __webpack_public_path__ + "static/media/choose-the-right-paver-color-stairs2.cf7bacb7.jpg";